import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, resolveDirective as _resolveDirective, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "text-center mb-13" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", { class: "d-md-block d-none mb-3" }, "Invite People", -1)
const _hoisted_3 = {
  key: 0,
  class: "fs-5"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("strong", null, "Members", -1)
const _hoisted_5 = {
  key: 1,
  class: "alert alert-primary d-flex align-items-center p-5 mb-4"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-column" }, [
  /*#__PURE__*/_createElementVNode("h4", { class: "mb-1 text-black" }, [
    /*#__PURE__*/_createTextVNode("FYI, you're adding people to your "),
    /*#__PURE__*/_createElementVNode("strong", null, "organization")
  ]),
  /*#__PURE__*/_createElementVNode("span", { class: "text-black" }, "Adding people to your organization will give them access to all productions. If you want to add cast & crew, we recommend inviting them from within the specific production.")
], -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = { class: "fs-5" }
const _hoisted_9 = { class: "row mb-1" }
const _hoisted_10 = { class: "col-md-4 col-sm-12 mb-1 mb-md-3" }
const _hoisted_11 = { class: "col-md-4 col-sm-12 mb-1 mb-md-3" }
const _hoisted_12 = { class: "col-md-4 col-sm-12 mb-1 mb-md-3" }
const _hoisted_13 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_14 = { class: "d-flex justify-content-center mb-1" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "fs-6 fw-bold mb-2" }, "To Be Invited", -1)
const _hoisted_16 = { class: "mh-300px scroll-y me-n7 pe-7" }
const _hoisted_17 = { class: "d-flex align-items-center" }
const _hoisted_18 = { class: "ms-5" }
const _hoisted_19 = { class: "fs-5 fw-bolder text-white mb-2" }
const _hoisted_20 = { class: "fw-bold text-muted" }
const _hoisted_21 = { class: "ms-2" }
const _hoisted_22 = { class: "d-flex" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputGroup = _resolveComponent("InputGroup")!
  const _component_Selector2 = _resolveComponent("Selector2")!
  const _component_Button = _resolveComponent("Button")!
  const _component_ModalBase = _resolveComponent("ModalBase")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createBlock(_component_ModalBase, {
    title: "Add People",
    size: "modal-lg",
    ref: "modal",
    "has-footer": true,
    "element-loading-text": "Please Wait"
  }, {
    body: _withCtx(() => [
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_1, [
          _hoisted_2,
          (!_ctx.isOrganization)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createTextVNode("Add your cast & crew as "),
                _hoisted_4,
                _createTextVNode(" to give them access to schedules and communications. ")
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_7)),
          _createElementVNode("div", _hoisted_8, [
            _createTextVNode("Or, have your members request access themselves, using your StageCode: "),
            _createElementVNode("strong", null, _toDisplayString(_ctx.stageCode), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_InputGroup, {
              label: "Email/StageCode",
              "is-required": true
            }, {
              default: _withCtx(() => [
                _withDirectives(_createElementVNode("input", {
                  class: _normalizeClass(["form-control", {'is-invalid': _ctx.v$.personModel.lookupValue.$error}]),
                  type: "text",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.personModel.lookupValue) = $event))
                }, null, 2), [
                  [_vModelText, _ctx.personModel.lookupValue]
                ])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createVNode(_component_InputGroup, {
              "is-required": true,
              label: _ctx.titleLabel
            }, {
              default: _withCtx(() => [
                _withDirectives(_createElementVNode("input", {
                  class: _normalizeClass(["form-control", {'is-invalid': _ctx.v$.personModel.title.$error}]),
                  type: "text",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.personModel.title) = $event))
                }, null, 2), [
                  [_vModelText, _ctx.personModel.title]
                ])
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createVNode(_component_InputGroup, {
              "is-required": true,
              label: "Role",
              tooltip: _ctx.roleTooltip
            }, {
              default: _withCtx(() => [
                _createVNode(_component_Selector2, {
                  class: "",
                  options: _ctx.roleOptions,
                  required: true,
                  modelValue: _ctx.personModel.role,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.personModel.role) = $event))
                }, null, 8, ["options", "modelValue"]),
                (_ctx.v$.personModel.role.$error)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_13, "You must assign a role."))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["tooltip"])
          ])
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createVNode(_component_Button, {
            class: "",
            onClick: _ctx.addPerson
          }, {
            default: _withCtx(() => [
              _createTextVNode("Add to list")
            ]),
            _: 1
          }, 8, ["onClick"])
        ]),
        _createElementVNode("div", null, [
          _hoisted_15,
          _createElementVNode("div", _hoisted_16, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.peopleToAdd, (person) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "d-flex flex-stack py-4 border-bottom border-gray-300 border-bottom-dashed",
                key: person.lookupValue
              }, [
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("div", _hoisted_19, _toDisplayString(person.lookupValue), 1),
                    _createElementVNode("div", _hoisted_20, _toDisplayString(person.title), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_21, [
                  _createVNode(_component_Selector2, {
                    class: "",
                    options: _ctx.roleOptions,
                    modelValue: person.role,
                    "onUpdate:modelValue": ($event: any) => ((person.role) = $event)
                  }, null, 8, ["options", "modelValue", "onUpdate:modelValue"])
                ])
              ]))
            }), 128))
          ])
        ])
      ])
    ]),
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_22, [
        _createVNode(_component_Button, {
          onClick: _ctx.submit,
          "is-disabled": _ctx.peopleToAdd.length === 0,
          type: "primary",
          class: "ms-auto text-white"
        }, {
          default: _withCtx(() => [
            _createTextVNode("Send Invitations ")
          ]),
          _: 1
        }, 8, ["onClick", "is-disabled"])
      ])
    ]),
    _: 1
  })), [
    [_directive_loading, _ctx.isLoading]
  ])
}